import { Link, LinkComponentProps } from '@tanstack/react-router';

export const HeaderLink = ({ to, children, ...props }: LinkComponentProps<'a'>) => {
  return (
    <Link
      className="flex xl:h-full items-center px-3 text-base hover:text-primary"
      to={to}
      inactiveProps={{
        className: 'text-muted-foreground font-normal',
      }}
      activeProps={{
        className: 'text-link border-b-2 border-[var(--link)] font-medium',
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
